import React from 'react';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';

type AccommodationsRootProps = Readonly<{
  header: React.ReactNode;
  tabs: React.ReactNode;
  content: React.ReactNode;
  dialogs: React.ReactNode;
}>;

const AccommodationsRoot: React.FC<AccommodationsRootProps> = ({ tabs, header, content, dialogs }) => {
  // Desktop only: containing block so the desktop popover tooltips' position:fixed anchors resolve to this
  // panel (restores what #15270's cross-fade dropped). Omitted on mobile/tablet, where the tooltips render
  // as viewport-fixed bottom sheets that must NOT be contained to the (tall) panel.
  const isMobileOrTablet = useIsMobileOrTablet();

  return (
    <Flex
      flexDirection="column"
      height="auto"
      paddingBottom={pxToRem(128)}
      gap={6}
      transform={isMobileOrTablet ? undefined : 'translateZ(0)'}
    >
      {tabs}
      <Flex
        flexDirection="column"
        gap={6}
      >
        {header}
        {content}
      </Flex>
      {dialogs}
    </Flex>
  );
};

export default AccommodationsRoot;
